// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__svfkc","topBottomGutter":"Layout_topBottomGutter__1NScb"};